import React, { useState, useEffect } from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import FooterCard from "components/footers/PageFooter";
import PageHeader from "components/headers/PageHeader";
import EventCard from "components/other-cards/EventCard";
import EnquiryCard from "components/home-cards/EnquiryCard";

export default () => {

  useEffect(() => {
    document.body.style.overflow = 'auto'
  });

  return (
    <AnimationRevealPage>
      <PageHeader pageName="Events & Activities" titleName="" />
      <EventCard />
      <EnquiryCard />
      <FooterCard />
    </AnimationRevealPage>
  );

};
